export function getAll() {
  return [
    {
      value: 0,
      name: "All",
      text: "全部",
    },
    {
      value: 1,
      name: "NoPayed",
      text: "未付款",
    },
    {
      value: 2,
      name: "DepositPayed",
      text: "已付訂",
    },
    {
      value: 3,
      name: "FinalPaymentPayed",
      text: "已完成",
    },
    {
      value: 4,
      name: "IsVoided",
      text: "已作廢",
    },
    {
      value: 5,
      name: "WaitingPickup",
      text: "待取貨",
    },
    {
      value: 6,
      name: "Prepared",
      text: "已備貨",
    },
    {
      value: 7,
      name: "IsCanceled",
      text: "已退訂",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
